import data from '../../assets/json/products.json';
import { API_TIMEOUT } from '../../config/app';
import { LoremIpsum } from 'lorem-ipsum';
import { catalog, objectId } from './catalog';

const lorem = new LoremIpsum({
    sentencesPerParagraph: {
        max: 8,
        min: 4
    },
    wordsPerSentence: {
        max: 16,
        min: 4
    }
});

const seed = data.map((item) => ({
    id: objectId(),
    icon: item.icon,
    name: item.category,
    description: lorem.generateSentences(4)
}));

export const Category = catalog('categories', seed);

export const list = ({ filter = '', page = 1, size = 10 }) => {
    return new Promise((resolve, reject) => {
        const categories = Category.all();
        const query = categories.filter(
            (c) =>
                c.name.toLowerCase().includes(filter.toLowerCase()) ||
                c.description.toLowerCase().includes(filter.toLowerCase())
        );
        const start = (page - 1) * size;
        const end = start + size;
        const total = query.length;
        const records = query.slice(start, end);
        setTimeout(() => {
            resolve({
                success: true,
                data: {
                    page,
                    size,
                    total,
                    records
                }
            });
        }, API_TIMEOUT);
    });
};

export const get = (id) => {
    return new Promise((resolve, reject) => {
        const category = Category.find(id);
        setTimeout(() => {
            resolve({
                success: true,
                data: {
                    record: category
                }
            });
        }, API_TIMEOUT);
    });
};

export const create = (item) => {
    return new Promise((resolve, reject) => {
        const category = { id: objectId(), ...item };
        Category.add(category);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'Category created successfully.',
                data: {
                    record: category
                }
            });
        }, API_TIMEOUT);
    });
};

export const update = (item) => {
    return new Promise((resolve, reject) => {
        Category.update(item.id, item);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'Category updated successfully.'
            });
        }, API_TIMEOUT);
    });
};

export const remove = (id) => {
    return new Promise((resolve, reject) => {
        Category.remove(id);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'Category deleted successfully.'
            });
        }, API_TIMEOUT);
    });
};
